import React, { useState, useEffect } from 'react';
import Select from "react-select";
import { useNavigate, useLocation } from "react-router-dom";
import Swal from "sweetalert2";
import Table from 'react-bootstrap/Table';
import { toast } from "react-toastify";
import * as api from "../../../api_function";
import load from "../../../assets/Images/loader.gif";
import { logDOM } from '@testing-library/react';


const optionAccessPointCount = [
    { label: "2", value: "2" },
    { label: "3", value: "3" },
    { label: "4", value: "4" },
    { label: "5", value: "5" },
    { label: "6", value: "6" },
];

const optionWiredLanDevices = [
    { label: "Biometrics", value: "Biometrics" },
    { label: "Printers", value: "Printers" },
    { label: "CCTV", value: "CCTV" },
    { label: "IoT Devices", value: "IoTDevices" },
    { label: "Desktop PCs", value: "DesktopPCs" },
    { label: "Laptops", value: "Laptops" },
    { label: "DVR/NVR", value: "DvrNvr" },
    { label: "Smart TVs", value: "SmartTVs" },
    { label: "Other", value: "OtherWiredLanDevice" },
];



// const optionWiredLanDevices = [
//     { label: "Biometrics", value: "1" },
//     { label: "Printers", value: "1" },
//     { label: "CCTV", value: "1" },
//     { label: "IoT Devices", value: "1" },
//     { label: "Desktop PCs", value: "1" },
//     { label: "Laptops", value: "1" },
//     { label: "DVR/NVR", value: "1" },
//     { label: "Smart TVs", value: "1" },
//     { label: "Other", value: "1" },
// ]




const SelectProductProwifi = () => {
    const style = {
        control: (base) => ({
            ...base,
            border: 0,
            // Remove box shadow
            boxShadow: "none",
            backgroundColor: "transparent",
            color: "black",
        }),
    };
    const [loading, setLoading] = useState(false);
    const [noOfUnit, setNoOfUnit] = useState("");
    const [totalEmpCount, setTotalEmpCount] = useState("");
    const [getPlanName, setGetOptionPlanName] = useState("");
    const [bothOptionPlanName, setBothOptionPlanName] = useState("");
    const [bothOptionAPCount, setBothOptionAPCount] = useState("");
    const [bothOptionsNeedsgenerated, setBothOptionsNeedsgenerated] = useState("");


    const [totalCarpetArea, setTotalCarpetArea] = useState("");
    const [additionAccessPointCount, setAdditionAccessPointCount] = useState("");
    const [accessPointCount, setAccessPointCount] = useState("");

    const [planName, setPlanName] = useState("");
    const [optionProductName, setOptionProductName] = useState("");
    const [optionPlanName, setOptionPlanName] = useState([]);
    const [recommendedPlanTier, setRecommendedPlanTier] = useState("");
    const [recommendedPlanLabel, setRecommendedPlanLabel] = useState("");
    const [recommendedAps, setRecommendedAps] = useState("");
    const [recommendedPlan, setRecommendedPlan] = useState("");
    const [recommendedPlanValue, setRecommendedPlanValue] = useState("");
    const [selectedOption, setSelectedOption] = useState("");

    const [proposalCounter, setProposalCounter] = useState("");
    const [oppStatus, setOppStatus] = useState("");

    const [planDataAB, setPlanDataAB] = useState([]);
    const [planDataShowAB, setPlanDataShowAB] = useState([]);

    const [planDataBoth, setPlanDataBoth] = useState([]);
    const [tableData, setTableData] = useState({
        basePlan: { PlanName: "" },
        optionA: {},
        optionB: {}
    });

    const [basePriceDisA, setBasePriceDisA] = useState(""); // Discount Percentage
    const [basePriceDisB, setBasePriceDisB] = useState("");
    const [discountedBasePriceA, setDiscountedBasePriceA] = useState("");
    const [discountedBasePriceB, setDiscountedBasePriceB] = useState("");

    const [otcPriceA, setOtcPriceA] = useState("");
    const [otcPriceB, setOtcPriceB] = useState("");
    const [maxOtcPriceB, setMaxOtcPriceB] = useState("");

    const [doesCustNeedStaticIP, setDoesCustNeedStaticIP] = useState("");



    const [userPriceData, setUserPriceData] = useState({
        basePriceReasonA: "",
        basePriceReasonB: ""
    });

    const handleChange = (e) => {
        // console.log(e.target.name, e.target.value);
        setUserPriceData({ ...userPriceData, [e.target.name]: e.target.value });
    };

    const [wiredLanDevices, setWiredLanDevices] = useState([]);
    const [noOfWiredLan, setNoOfWiredLan] = useState("");
    const [lanPortAddonCharges, setLanPortAddonCharges] = useState("");
    const [lanPortAddonDiscount, setLanPortAddonDiscount] = useState("");
    const [extendedLanCharges, setExtendedLanCharges] = useState("");
    const [nameOfOtherWLD, setNameOfOtherWLD] = useState("");

    const [otc, setOtc] = useState(0);

    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const OppId = searchParams.get("OppId");
    const navigate = useNavigate();



    useEffect(() => {
        const fetchData = async () => {
            try {
                setLoading(true);
                const apiUrl = process.env.REACT_APP_API_URL;
                const requestBody = {
                    Action: "getopportunity",
                    Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                    LeadId: "",
                    OppId: OppId ? OppId : "",
                    password: sessionStorage.getItem('password'),
                    userName: sessionStorage.getItem('userName'),
                };
                const response = await fetch(apiUrl, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(requestBody),
                });

                const responsedata = await response.json();
                const responseData = responsedata?.Response?.Data?.[0];
                if (responsedata?.Status === "Success" && responseData) {

                    setProposalCounter(responsedata.Response.Data[0]?.PgInfo.ProposalCounter);
                    setOppStatus(responsedata.Response?.Data[0]?.Status);
                    setNoOfUnit(responsedata.Response?.Data[0]?.PgInfo?.NoOfUnits);
                    setTotalCarpetArea(responsedata.Response?.Data[0]?.PgInfo?.OfficeArea);
                    setTotalEmpCount(responsedata.Response?.Data[0]?.PgInfo?.EmployeeCount);
                    setDoesCustNeedStaticIP(responsedata.Response?.Data[0]?.PgInfo?.Doesthecustomerneedastaticip);
                    setBothOptionPlanName(responsedata.Response?.Data[0]?.PgInfo?.BothOptionPlanName);
                    setGetOptionPlanName(responsedata.Response?.Data[0]?.PgInfo?.BasePlanName);
                    setBothOptionAPCount(responsedata.Response?.Data[0]?.PgInfo?.BothOptionAPCount);
                    setBothOptionsNeedsgenerated(responsedata.Response?.Data[0]?.PgInfo?.BothOptionsNeedsgenerated);
                    setNameOfOtherWLD(responsedata.Response?.Data[0]?.PgInfo?.NameOfOtherWLD);
                    setLanPortAddonCharges(responsedata.Response?.Data[0]?.PgInfo?.LANPortAddonCharges);
                    setNoOfWiredLan(responsedata.Response?.Data[0]?.PgInfo?.NumberofWiredLANPorts);
                    setLanPortAddonDiscount(responsedata.Response?.Data[0]?.PgInfo?.LanportaddDiscountPrice)
                    const pgInfo = responseData.PgInfo;

                    const selectedDevices = optionWiredLanDevices?.filter((opt) => {
                        const key = opt.value; // must match API field name
                        return pgInfo[key] === "1";
                    });
                    setWiredLanDevices(selectedDevices);


                    if (responsedata.Response.Data[0]?.PgInfo.ProposalCounter !== "" || responsedata.Response.Data[0]?.PgInfo.ProposalCounter !== "0") {

                        // setPlanName({
                        //     value: responsedata?.Response?.Data[0]?.PgInfo?.BasePlanName,
                        //     label: responsedata?.Response?.Data[0]?.PgInfo?.BasePlanName,
                        // })
                        // setPlanName(optionPlanName.find(item => item.value === responsedata.Response?.Data[0]?.PgInfo?.BothOptionPlanName));
                        setAccessPointCount(optionAccessPointCount?.find(item => item.value === responsedata.Response?.Data[0]?.PgInfo?.APcount));
                    }

                }

            } catch (error) {
                console.error("Error fetching data:", error);
            } finally {
                setLoading(false);
            }
        };
        fetchData();
    }, [OppId]);


    useEffect(() => {
        if (doesCustNeedStaticIP == "111260000") {
            const apCount = Number(accessPointCount.value) || "";
            const additionalPrice = Number(additionAccessPointCount) || 0;
            // const planOtc = planDataAB.otc;
            const planOtc = 50000;

            const calculatedOtc = Number(planOtc) + Math.max(apCount - 1, 0) * additionalPrice;
            // console.log("planOtc", planOtc);
            // console.log("apCount", accessPointCount.value);
            // console.log("additionalPrice", additionalPrice);
            // console.log("calculatedOtc", calculatedOtc);
            setOtc(calculatedOtc);
        } else {
            const apCount = Number(accessPointCount.value) || "";
            const additionalPrice = Number(additionAccessPointCount) || 0;
            // const planOtc = planDataAB.otc;
            const planOtc = 40000;
            const calculatedOtc = Number(planOtc) + Math.max(apCount - 2, 0) * additionalPrice;
            // console.log("planOtc", planOtc);
            // console.log("apCount", accessPointCount.value);
            // console.log("additionalPrice", additionalPrice);
            // console.log("calculatedOtc", calculatedOtc);
            setOtc(calculatedOtc);
        }
    }, [planDataAB?.otc, accessPointCount, additionAccessPointCount]);


    // console.log("otc",otc);



    // When optionPlanName gets populated, sync PlanName once
    // useEffect(() => {
    //     if (
    //         proposalCounter !== "" &&
    //         proposalCounter !== "0" &&
    //         bothOptionPlanName &&
    //         optionPlanName.length > 0
    //     ) {
    //         const matched = optionPlanName.find(
    //             (opt) => opt.value === bothOptionPlanName
    //         );
    //         if (matched) setPlanName(matched);


    //     }
    // }, [optionPlanName, bothOptionPlanName, proposalCounter]);

    // useEffect for setting plan name
    useEffect(() => {
        if (
            proposalCounter !== "" &&
            proposalCounter !== "0" &&
            getPlanName &&
            optionPlanName.length > 0
        ) {
            // remove trailing underscore + letter (e.g. "_A", "_B", "_C")
            const cleanName = getPlanName.replace(/_[A-Z]$/i, "").trim();

            const matched = optionPlanName.find(
                (opt) => opt.value?.trim().toLowerCase() === cleanName.toLowerCase() ||
                    opt.label?.trim().toLowerCase() === cleanName.toLowerCase()
            );

            if (matched) {
                setPlanName(matched);
            } else {
                console.warn("No plan matched for:", cleanName);
            }
        }
    }, [optionPlanName, bothOptionPlanName, proposalCounter]);






    useEffect(() => {
        const fetchData = async () => {
            try {
                const url = process.env.REACT_APP_API_URL;
                const RequestBody = {
                    "Action": "recommendedPlan",
                    "Authkey": "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                    "empCount": totalEmpCount,
                    "area": totalCarpetArea,
                    "smbType": doesCustNeedStaticIP == "111260000" ? "PBV" : ""
                }
                const Response = await fetch(url, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(RequestBody),
                });
                const data = await Response.json();
                // console.log("data", data);
                setRecommendedAps(data.Response[0].access_point_count);
                setRecommendedPlan(data.Response[0].plan_description)
                setRecommendedPlanValue(data.Response[0].plan_tier)

                setRecommendedPlanTier(data.Response[0].plan_tier);
                setRecommendedPlanLabel(data.Response[0].plan_description);
                setRecommendedSpecs(parsePlanSpecs(data.Response[0].plan_description));
                // if (data.Response) {
                //     const options = data.Response.map(
                //         (option) => ({
                //             label: option.access_point_count,
                //             value: option.access_point_count,
                //         })
                //     );
                //     setOptionAccessPointCount(options);

                // } else {
                //     setOptionAccessPointCount([])
                // }

            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };
        fetchData();
    }, [totalEmpCount, totalCarpetArea]);


    function parsePlanSpecs(description = "") {
        const speedMatch = description.match(/(\d+(?:\.\d+)?)\s*(Gbps|Mbps)/i);
        const dataMatch = description.match(/(\d+(?:\.\d+)?)\s*TB/i);
        const apMatch = description.match(/(\d+)\s*AP/i);

        let speedMbps = 0;
        if (speedMatch) {
            const val = parseFloat(speedMatch[1]);
            const unit = speedMatch[2].toLowerCase();
            speedMbps = unit === "gbps" ? val * 1000 : val;
        }

        const dataTB = dataMatch ? parseFloat(dataMatch[1]) : 0;
        const apCountParsed = apMatch ? parseInt(apMatch[1], 10) : 0;

        return { speedMbps, dataTB, apCount: apCountParsed };
    }

    // New state for recommended specs
    const [recommendedSpecs, setRecommendedSpecs] = useState({ speedMbps: 0, dataTB: 0, apCount: 0 });


    useEffect(() => {
        const fetchData = async () => {
            try {
                const url = process.env.REACT_APP_API_URL;
                const RequestBody = {
                    Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                    Action: "getOfficePlanNameList",
                    apCount: accessPointCount ? accessPointCount?.value : recommendedAps,
                    smbType: doesCustNeedStaticIP == "111260000" ? "PBV" : ""
                };

                const Response = await fetch(url, {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify(RequestBody),
                });

                const data = await Response.json();
                console.log("data", data.Response?.[0]);

                if (data.Response && Array.isArray(data.Response)) {
                    // 👉 Enrich every option with parsed speed/data/AP
                    const options = data.Response.map((option) => {
                        const specs = parsePlanSpecs(option.plan_description);
                        return {
                            label: option.plan_description,   // shown in UI
                            value: option.plan_tier,          // "ProFi Value" etc
                            plan_name: option.plan_name,
                            plan_tier: option.plan_tier,
                            ...specs,                         // speedMbps, dataTB, apCount
                            _raw: option,                     // keep original if needed
                        };
                    });

                    setOptionPlanName(options);

                    // 👉 Recommended (assuming index 0 is recommended, as in your code)
                    const rec = data.Response[0];
                    // setRecommendedPlanTier(rec.plan_tier);
                    // setRecommendedPlanLabel(rec.plan_description);
                    // setRecommendedSpecs(parsePlanSpecs(rec.plan_description));
                } else {
                    setOptionPlanName([]);
                }
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };
        fetchData();
    }, [recommendedAps, accessPointCount]);


    useEffect(() => {
        if (proposalCounter == "" || proposalCounter == "0") {
            if (recommendedPlanValue && optionPlanName.length > 0) {
                const matched = optionPlanName.find(opt => opt.value === recommendedPlanValue);
                if (matched) {
                    setPlanName(matched); // setPlanName expects { value, label }
                }
            }
            return;
        }
    }, [recommendedPlanValue, optionPlanName]);



    const handleSelectAccessPointCount = (select) => {
        setAccessPointCount(select);
        setSelectedOption("");
        // setPlanName("");
    }


    const planTiers = ["ProFi Starter", "ProFi Value", "ProFi Plus", "ProFi Ultra"];

    const [overrideConfirm, setOverrideConfirm] = useState(false);
    const [upgradeNote, setUpgradeNote] = useState(""); // optional note for upsells

    const normalize = (s) => (s || "").toString().trim().toLowerCase();




    const handleSelectPlanName = (selectedOption) => {
        // reset flags each change
        setOverrideConfirm(false);
        setUpgradeNote("");

        console.log("selectedOption", selectedOption);


        if (!selectedOption) {
            setPlanName(null);
            return;
        }

        // 🔹 NEW RULE: Block Starter/Value if Desktop PCs/Laptops selected
        const hasRestrictedDevice = wiredLanDevices?.some(
            (item) => item.value === "DesktopPCs" || item.value === "Laptops"
        );

        if (
            hasRestrictedDevice &&
            (selectedOption.value === "ProFi Starter" || selectedOption.value === "ProFi Value")
        ) {
            // toast.error(
            //     'LAN connectivity for Desktop PCs/Laptops is NOT allowed with "Starter" or "Value" plans. Please select Plus (800 Mbps) or Ultra (1 Gbps).',
            //     {
            //         position: toast.POSITION.BOTTOM_CENTER,
            //         autoClose: 3000,
            //     }
            // );
            alert(
                `LAN connectivity for Desktop PCs/Laptops is NOT allowed with "Starter" or "Value" plans. Please select Plus (800 Mbps) or Ultra (1 Gbps).`
            );
            setPlanName("");
            return; // 🚫 block plan selection
        }

        // Selected specs from enriched option
        const sel = {
            speedMbps: selectedOption.speedMbps || 0,
            dataTB: selectedOption.dataTB || 0,
        };
        // console.log("sel",sel);
        // Recommended specs from state
        const rec = {
            speedMbps: recommendedSpecs.speedMbps || 0,
            dataTB: recommendedSpecs.dataTB || 0,
        };

        // console.log("rec",rec);


        // If we don't have numbers, accept silently
        // if (!rec.speedMbps || !rec.dataTB || !sel.speedMbps || !sel.dataTB) {
        //     console.warn("Missing spec values for comparison", { rec, sel, selectedOption });
        //     setPlanName(selectedOption);
        //     return;
        // }

        // Non-overlapping classification
        const isUpsell =
            (sel.speedMbps >= rec.speedMbps && sel.dataTB >= rec.dataTB) &&
            (sel.speedMbps > rec.speedMbps || sel.dataTB > rec.dataTB);

        const isDowngrade =
            (sel.speedMbps <= rec.speedMbps && sel.dataTB <= rec.dataTB) &&
            (sel.speedMbps < rec.speedMbps || sel.dataTB < rec.dataTB);

        // Mixed = one higher, one lower
        const isMixed = !isUpsell && !isDowngrade;

        if (isDowngrade) {
            // Severity by worst loss
            const speedRatio = rec.speedMbps / Math.max(sel.speedMbps, 1);
            const dataRatio = rec.dataTB / Math.max(sel.dataTB, 1);
            const worstRatio = Math.max(speedRatio, dataRatio);

            // console.log("speedRatio",speedRatio);
            // console.log("dataRatio",dataRatio);
            // console.log("worstRatio",worstRatio);


            if (worstRatio > 1 && worstRatio <= 2) {
                alert(
                    `Warning: Based on ${totalEmpCount || 0} employees and ${totalCarpetArea || 0} sq.ft., the "${recommendedPlanLabel}" plan was recommended. The "${selectedOption.value}" plan may not provide sufficient bandwidth or data for this office’s needs.`
                );
                setPlanName(selectedOption);
            } else if (worstRatio > 2) {
                const confirmOverride = window.confirm(
                    `Selected plan is significantly lower than recommended; customer may experience slow speeds or data overages.\n\nRecommended: "${recommendedPlanLabel}"\nSelected: "${selectedOption.value}"\n\nClick OK to confirm override.`
                );
                if (confirmOverride) {
                    setOverrideConfirm(true);
                    setPlanName(selectedOption);
                } else {
                    // keep previous selection
                }
            } else {
                setPlanName(selectedOption);
            }
        } else if (isUpsell) {
            setPlanName(selectedOption);
            setUpgradeNote(
                `${selectedOption.value} selected (higher than recommended) – ensure customer is aware of additional cost.`
            );
        } else {
            setPlanName(selectedOption);
        }
    };





    const handleChangeLanPortAddonDiscount = (e) => {
        let value = Number(e.target.value);
        const lanDiscountLimit = lanPortAddonCharges * 0.5;
        if (value > lanDiscountLimit) {
            alert(`Discount cannot exceed ₹${lanDiscountLimit}`);
            setLanPortAddonDiscount("");
            return;
        }

        setLanPortAddonDiscount(value);
        const extendedLanChargesvalue = lanPortAddonCharges - value;
        console.log("extendedLanCharges", extendedLanChargesvalue);
        setExtendedLanCharges(extendedLanChargesvalue);
    };

    const handleChangeLanPortAddonCharges = (e) => {
        setLanPortAddonCharges(e.target.value);
    };

    const handleChangeNameOfOtherWLD = (e) => {
        setNameOfOtherWLD(e.target.value);
    };

    const handleChangeNoOfWiredLan = (e) => {
        const value = e.target.value.replace(/\D/g, "");
        // Validation: prevent values greater than 8
        if (value && parseInt(value, 10) > 7) {
            toast.warning("Number of Wired LAN Ports cannot exceed 8", {
                position: toast.POSITION.BOTTOM_CENTER,
                autoClose: 1500,
            });
            return; // Don't update state if value is greater than 8
        }
        if (value && parseInt(value, 10) < 1) {
            setWiredLanDevices([]);
            setLanPortAddonCharges("");
            setNameOfOtherWLD("")
        }
        setNoOfWiredLan(value);

        if (value) {
            const ports = parseInt(value, 10);

            let addon = 0;
            if (ports > 0 && ports <= 8 && doesCustNeedStaticIP == "111260000") {
                addon = 1500;
            } else if (ports > 0 && ports <= 8 && doesCustNeedStaticIP == "111260001") {
                addon = 1000;
            } else if (ports > 8) {
                addon = 1500 + (ports - 8) * 1500;
            }

            setLanPortAddonCharges(addon.toString());
        } else {
            setLanPortAddonCharges(""); // reset if empty
        }
    };



    // const handleSelectWiredLanDevices = (selectedOptions) => {
    //     setWiredLanDevices(selectedOptions || []); // always array
    // };

    const handleSelectWiredLanDevices = (selected) => {
        if (selected && selected.length > Number(noOfWiredLan)) {
            toast.warning(
                "The number of Wired LAN Device options selected should not exceed the number of Wired LAN ports entered.",
                {
                    position: toast.POSITION.BOTTOM_CENTER,
                    autoClose: 3000,
                }
            );
            return;
        }
        setWiredLanDevices(selected);

        const hasOtherDevice = selected?.some(
            (item) => item.value === "OtherWiredLanDevice"
        );

        if (!hasOtherDevice) {
            setNameOfOtherWLD("");
        }

        // Check if Desktop PCs or Laptops selected
        const hasRestrictedDevice = selected?.some(
            (item) => item.value === "DesktopPCs" || item.value === "Laptops"
        );

        // Allowed plans
        const allowedPlans = ["Plus (800 Mbps)", "Ultra (1 Gbps)"];

        if (hasRestrictedDevice && planName && !allowedPlans.includes(planName) && doesCustNeedStaticIP == "111260001") {
            toast.warning(
                "LAN connectivity for Desktop PCs/Laptops is allowed only with Plus (800 Mbps) or Ultra (1 Gbps) plans. Please update the plan accordingly.",
                {
                    position: toast.POSITION.BOTTOM_CENTER,
                    autoClose: 3000,
                }
            );
        }
    };

    useEffect(() => {
        if (proposalCounter == "" || proposalCounter == "0") {
            const finalAccessPointOptions = [
                ...(doesCustNeedStaticIP == "111260000"
                    ? [{ label: "1", value: "1" }]
                    : []),
                ...optionAccessPointCount,
            ];

            // if (recommendedAps && optionAccessPointCount.length > 0) {

            //     const matched = optionAccessPointCount.find(opt => opt.value === recommendedAps);
            //     if (matched) {
            //         setAccessPointCount(matched);
            //     }
            // }   
            if (recommendedAps && finalAccessPointOptions) {
                const matched = finalAccessPointOptions.find(
                    opt => opt.value === String(recommendedAps)
                );

                console.log("matched", matched);


                if (matched) {
                    setAccessPointCount(matched);
                }
            }
            return;
        }
    }, [recommendedAps, optionAccessPointCount, doesCustNeedStaticIP, proposalCounter]);



    const handleTotalEmpCount = (e) => {
        setTotalEmpCount(e.target.value);
    };
    const handleTotalCarpetArea = (e) => {
        setTotalCarpetArea(e.target.value);
    };

    const handleNoOfUnit = (e) => {
        setNoOfUnit(e.target.value)
    }

    const handleRecommendedAps = (e) => {
        setRecommendedAps(e.target.value)
    }
    const handleRecommendedPlan = (e) => {
        setRecommendedPlan(e.target.value)
    }




    useEffect(() => {
        const fetchPlans = async () => {
            try {
                const apiUrl = process.env.REACT_APP_API_URL_3;
                const requestData = {
                    "Authkey": "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                    "Action": "getPlanOfficeByAB",
                    // "empCount": totalEmpCount,
                    // "area": totalCarpetArea,
                    "plan_tier": planName?.value ? planName?.value : "",
                    "planType": "B",
                    "ap": accessPointCount ? accessPointCount?.value : accessPointCount?.value,
                    "smbType": doesCustNeedStaticIP == "111260000" ? "PBV" : ""
                }
                const response = await fetch(apiUrl, {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify(requestData),
                });

                const result = await response.json();

                if (result.Status == "Success") {

                    setPlanDataAB(result.Response[0]);
                    setPlanDataShowAB(result.Response);

                    console.log("result.Response[0]", result.Response[0].otc);
                    if (result.Response[0].optionType == "B") {
                        setMaxOtcPriceB(result?.Response[0].max_discount_OTC);
                        setOtcPriceB(result?.Response[0].otc);
                        setOtc(result?.Response[0].otc);
                        setOtcPriceA("");
                        setBasePriceDisA("");
                        setUserPriceData({
                            basePriceReasonA: ""
                        })
                    } else {
                        setOtcPriceA(result?.Response[0].otc)
                        setOtcPriceB("");
                        setOtc("");
                        setBasePriceDisB("");
                        setUserPriceData({
                            basePriceReasonB: ""
                        })
                    }
                }
            } catch (error) {
                console.error("Error fetching Plans:", error);
            }

        };

        fetchPlans();
    }, [accessPointCount, planName]);







    useEffect(() => {
        if (basePriceDisB == "" || basePriceDisB == null) {
            setDiscountedBasePriceB("");
            return;
        }

        const discountLimit = otc;
        const value = Number(basePriceDisB);

        if (value > discountLimit) {
            setBasePriceDisB("");
            setDiscountedBasePriceB("");
            return;
        }

        const discountedOtcB = otc - value;
        setDiscountedBasePriceB(discountedOtcB);

    }, [basePriceDisB, otc]);

    const handleBasePriceDisB = (e) => {
        if (!additionAccessPointCount) {
            toast.warning("Additional APs Discounted must be selected", {
                position: toast.POSITION.BOTTOM_CENTER,
                autoClose: 1500,
            });
            return;
        }
        if (additionAccessPointCount) {
            if (Number(additionAccessPointCount) < 12000) {
                toast.warning("Additional APs Discounted Price should not be less than 12000", {
                    position: toast.POSITION.BOTTOM_CENTER,
                    autoClose: 1500,
                });
                return;
            }
        }
        let value = Number(e.target.value);

        const baseOTC_B = otcPriceB; // Dynamic OTC price
        const floorPrice = 40000; // Minimum allowed base price

        // Plan discount limits (on floor price)
        const discountLimits = {
            "ProFi Starter": 5000,
            "ProFi Value": 10000,
            "ProFi Plus": 10000,
            "ProFi Ultra": 10000
        };
        // const discountLimit = maxOtcPriceB;otc
        // const discountLimit = otcPriceB;
        const discountLimit = otc;
        console.log("otc", otc);

        // Validation
        if (value > discountLimit) {
            alert(`Discount cannot exceed ₹${discountLimit}`);
            setBasePriceDisB(""); // Clear input if invalid
            return;
        }

        setBasePriceDisB(value);
        // const discountedOtcB = otcPriceB - value;
        const discountedOtcB = otc - value;
        // console.log("discountedOtcB", discountedOtcB);
        setDiscountedBasePriceB(discountedOtcB);
    };


    const buildLanDevicesPayload = () => {
        const payload = {};
        optionWiredLanDevices?.forEach((device) => {
            payload[device.value] = wiredLanDevices?.some(
                (selected) => selected?.value === device.value
            )
                ? "1"
                : "0";
        });
        return payload;
    };


    useEffect(() => {
        const emp = Number(totalEmpCount);
        const area = Number(totalCarpetArea);

        if (!emp || !area) return; // prevent running when empty

        let hasRecommendedPlan = false;

        // Employee < 30
        if (emp < 30) {
            if (area > 0 && area <= 4500) {
                hasRecommendedPlan = true;
            }
        }

        // Employee 30–45
        else if (emp >= 30 && emp <= 45) {
            if (area >= 600 && area <= 4500) {
                hasRecommendedPlan = true;
            }
        }

        // Employee 46–65
        else if (emp >= 46 && emp <= 65) {
            if (area >= 600 && area <= 4500) {
                hasRecommendedPlan = true;
            }
        }

        // Employee 66–85
        else if (emp >= 66 && emp <= 85) {
            if (area >= 1501 && area <= 4500) {
                hasRecommendedPlan = true;
            }
        }

        // Employee 86–100
        else if (emp >= 86 && emp <= 100) {
            if (area >= 2251 && area <= 4500) {
                hasRecommendedPlan = true;
            }
        }

        if (!hasRecommendedPlan) {
            toast.warning(`No recommended plan is available in the grid for the selected combination (Total Carpet Area: ${area} sq. ft., Total Employee Count: ${emp}).`, {
                position: toast.POSITION.BOTTOM_CENTER,
                autoClose: 3000,
            });
        }

    }, [totalEmpCount, totalCarpetArea]);



    const handleCreateProductAB = async () => {
        // const hasOnlyOther = wiredLanDevices.every(
        //     (d) => d.value === "OtherWiredLanDevice"
        // );
        const hasOnlyOther =
            wiredLanDevices.length > 0 &&
            wiredLanDevices.every((d) => d.value === "OtherWiredLanDevice");

        // console.log("hasOnlyOther", hasOnlyOther);
        // console.log("wiredLanDevices", wiredLanDevices);
        // console.log("nameOfOtherWLD", nameOfOtherWLD);

        if (!additionAccessPointCount) {
            toast.warning("Additional APs Discounted must be selected", {
                position: toast.POSITION.BOTTOM_CENTER,
                autoClose: 1500,
            });
            return;
        }
        if (additionAccessPointCount) {
            if (Number(additionAccessPointCount) < 12000) {
                toast.warning("Additional APs Discounted Price should not be less than 12000", {
                    position: toast.POSITION.BOTTOM_CENTER,
                    autoClose: 1500,
                });
                return;
            }
        }
        if (Number(noOfWiredLan) > 0 && wiredLanDevices.length === 0) {
            toast.warning("Please Select at least One Wired LAN Device", {
                position: toast.POSITION.BOTTOM_CENTER,
                autoClose: 1500,
            });
            return;
        }
        if (hasOnlyOther) {
            if (!nameOfOtherWLD) {
                toast.warning("Please Enter Specific Device Name", {
                    position: toast.POSITION.BOTTOM_CENTER,
                    autoClose: 1500,
                });
                return;
            }
        }

        if (!planName) {
            toast.warning("Plan must be selected", {
                position: toast.POSITION.BOTTOM_CENTER,
                autoClose: 1500,
            });
            return;
        }
        if (basePriceDisB > 0 || lanPortAddonDiscount > 0) {
            if (!userPriceData?.basePriceReasonB) {
                toast.warning("Please Enter Discount Reason", {
                    position: toast.POSITION.BOTTOM_CENTER,
                    autoClose: 1500,
                });
                return;
            }
        }
        try {
            setLoading(true);
            const apiUrl = process.env.REACT_APP_API_URL_3;
            const isOptionA = planDataAB?.optionType === "A";
            const requestData = {
                "Authkey": "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                "Action": "updateOptyProductOfficeAB",
                "UserName": sessionStorage.getItem('userName'),
                "Password": sessionStorage.getItem('password'),
                "Baseplan": {
                    "OpportunityID": OppId || "",
                    "APCount": accessPointCount ? accessPointCount?.value : accessPointCount?.value,
                    "OptionType": doesCustNeedStaticIP == "111260001" ? `Option ${planDataAB.optionType}` : "",
                    "ProductID": planDataAB.crm_plan_id,
                    "RC": planDataAB.monthly_price,
                    "OTC": discountedBasePriceB ? discountedBasePriceB : otc,
                    "OTCPriceDiscount": isOptionA ? basePriceDisA : basePriceDisB,
                    "AdditionalAPCount": "",
                    "AdditionalAPsPrice": "0",
                    "AdditionalAPsDiscountPrice": additionAccessPointCount ? String(additionAccessPointCount) : "",
                    "DiscountReason": isOptionA ? userPriceData?.basePriceReasonA : userPriceData?.basePriceReasonB,
                    ...buildLanDevicesPayload(),
                    "NameOfOtherWLD": nameOfOtherWLD,
                    "NumberofWiredLANPorts": noOfWiredLan ? noOfWiredLan : "",
                    "LANPortAddonCharges": lanPortAddonCharges ? lanPortAddonCharges : "",
                    "LANPortAddDiscountPrice": lanPortAddonDiscount ? lanPortAddonDiscount : "",
                    "LANPortAddonExtendedPrice": extendedLanCharges ? extendedLanCharges : ""
                }
            }
            const response = await fetch(apiUrl, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(requestData),
            });
            const result = await response.json();
            if (result?.Response?.StatusCode == 200) {
                toast.success(result?.Response?.Message, {
                    position: toast.POSITION.BOTTOM_CENTER,
                    autoClose: 1500,
                });
                navigate(`/BusinessProWifiOpp?OppId=${OppId}`);
                setTimeout(async () => {
                    if (basePriceDisA > 0 || basePriceDisB > 0 || lanPortAddonDiscount > 0) {
                        try {
                            const apiUrl = process.env.REACT_APP_API_URL;
                            const requestData = {
                                "Authkey": "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                                "Action": "createApprovals",
                                "userName": sessionStorage.getItem("userName"),
                                "password": sessionStorage.getItem("password"),
                                "OppId": OppId,
                                "Reason": isOptionA ? userPriceData?.basePriceReasonA : userPriceData?.basePriceReasonB
                            }
                            const response = await fetch(apiUrl, {
                                method: "POST",
                                headers: { "Content-Type": "application/json" },
                                body: JSON.stringify(requestData),
                            });

                            const result = await response.json();
                            // console.log("Plan Response:", result.Response);
                            if (result?.Response?.StatusCode == 200) {
                                toast.success(result?.Response?.Message, {
                                    position: toast.POSITION.BOTTOM_CENTER,
                                    autoClose: 1500,
                                });
                            }

                        } catch (error) {
                            console.error("Error fetching Plans:", error.message);
                        }
                    }
                }, 5000);
            } else {
                toast.warning(result?.Response?.Message, {
                    position: toast.POSITION.BOTTOM_CENTER,
                    autoClose: 1500,
                });
            }
        } catch (error) {
            console.error("Error fetching discounts:", error.message);
        } finally {
            setLoading(false);
        }

    };












    const redirectOpportunity = () => {
        navigate(`/BusinessProWifiOpp?OppId=${OppId}`);
    };


    return (
        <>
            <div className="container-fluid text-light Header-style header">
                <div className="p-3">
                    <span
                        className=""
                        style={{ cursor: "pointer" }}
                        onClick={redirectOpportunity}
                    >
                        <i className="fa-solid fa-arrow-left-long"></i>
                    </span>
                    <span className="p-1 m-2">Plan Selector</span>
                </div>
            </div>

            {loading ? (
                <div className="loader-wrapper">
                    <div className="loader">
                        <img src={load} alt="loading...."></img>
                    </div>
                </div>
            ) : (
                <div className="container shadow mb-3 bg-body rounded form-container" id="form3">
                    <fieldset className="Company-details-form p-2">

                        <div className="row p-2">
                            <div className="col-12 col-md-6">
                                <div className="input-box form-floating">
                                    <input
                                        type="tel"
                                        placeholder=""
                                        className=" form-control input-text form-control-sm mt-1"
                                        id="noOfUnit"
                                        name="noOfUnit"
                                        maxLength="5"
                                        pattern="[0-9]{10}"
                                        value={noOfUnit}
                                        onChange={handleNoOfUnit}
                                        style={{ backgroundColor: "transparent" }}
                                        disabled
                                    />
                                    <label htmlFor="floatingInput" className="mt-2">
                                        No of Unit*
                                    </label>
                                </div>
                            </div>

                            <div className="col-12 col-md-6">
                                <div className="input-box form-floating">
                                    <input
                                        type="tel"
                                        placeholder=""
                                        className=" form-control input-text form-control-sm mt-1"
                                        id="totalCarpetArea"
                                        name="totalCarpetArea"
                                        maxLength="10"
                                        pattern="[0-9]{10}"
                                        value={totalCarpetArea}
                                        onChange={handleTotalCarpetArea}
                                        readOnly
                                        // readOnly={Number(noOfUnit) > 1}
                                        style={{ backgroundColor: "transparent" }}
                                        onKeyDown={(e) => {
                                            const allowedKeys = [
                                                "Backspace",
                                                "Delete",
                                                "ArrowLeft",
                                                "ArrowRight",
                                                "Tab",
                                            ];
                                            const isDigit = /\d/.test(e.key);
                                            if (
                                                (isDigit || allowedKeys.includes(e.key))
                                            ) {
                                                return true;
                                            } else {
                                                e.preventDefault();
                                            }
                                        }}
                                    />
                                    <label htmlFor="floatingInput" className="mt-2">
                                        Total Carpet Area
                                    </label>
                                </div>
                            </div>

                            <div className="col-12 col-md-6">
                                <div className="input-box form-floating">
                                    <input
                                        type="tel"
                                        placeholder=""
                                        className=" form-control input-text form-control-sm mt-1"
                                        id="totalEmpCount"
                                        name="totalEmpCount"
                                        maxLength="10"
                                        pattern="[0-9]{10}"
                                        value={totalEmpCount}
                                        onChange={handleTotalEmpCount}
                                        // readOnly={Number(noOfUnit) > 1}
                                        readOnly
                                        style={{ backgroundColor: "transparent" }}
                                        onKeyDown={(e) => {
                                            const allowedKeys = [
                                                "Backspace",
                                                "Delete",
                                                "ArrowLeft",
                                                "ArrowRight",
                                                "Tab",
                                            ];
                                            const isDigit = /\d/.test(e.key);
                                            if (
                                                (isDigit || allowedKeys.includes(e.key))

                                            ) {
                                                return true;
                                            } else {
                                                e.preventDefault();
                                            }
                                        }}
                                    />
                                    <label htmlFor="floatingInput" className="mt-2">
                                        Total Employee Count
                                    </label>
                                </div>
                            </div>


                            {/* {(proposalCounter !== "" && proposalCounter !== "0") && ( */}
                            <>
                                <div className="col-12 col-md-6">
                                    <div className="input-box form-floating">
                                        <input
                                            type="tel"
                                            placeholder=""
                                            className=" form-control input-text form-control-sm mt-1"
                                            id="recommendedAps"
                                            name="recommendedAps"
                                            maxLength="5"
                                            pattern="[0-9]{10}"
                                            value={recommendedAps}
                                            onChange={handleRecommendedAps}
                                            style={{ backgroundColor: "transparent" }}
                                            disabled
                                        />
                                        <label htmlFor="floatingInput" className="mt-2">
                                            Recommended APs Count
                                        </label>
                                    </div>
                                </div>

                                <div className="col-12 col-md-6">
                                    <div className="input-box form-floating">
                                        <input
                                            type="tel"
                                            placeholder=""
                                            className=" form-control input-text form-control-sm mt-1"
                                            id="recommendedPlan"
                                            name="recommendedPlan"
                                            maxLength="5"
                                            pattern="[0-9]{10}"
                                            value={recommendedPlan}
                                            onChange={handleRecommendedPlan}
                                            style={{ backgroundColor: "transparent" }}
                                            disabled
                                        />
                                        <label htmlFor="floatingInput" className="mt-2">
                                            Recommended Plan
                                        </label>
                                    </div>
                                </div>


                                <div className="col-12 col-md-6">
                                    <div className="input-box form-floating">
                                        <input
                                            type="text"
                                            placeholder=""
                                            className="form-control input-text form-control-sm mt-1"
                                            id="additionalAcAmount"
                                            name="additionalAcAmount"
                                            value={additionAccessPointCount}
                                            onChange={(e) => {
                                                setAdditionAccessPointCount(e.target.value);
                                            }}
                                            onBlur={(e) => {
                                                const numericValue = Number(e.target.value);

                                                if (numericValue && numericValue < 12000) {
                                                    toast.warning("Additional APs Discount should not be less than 12000", {
                                                        position: toast.POSITION.BOTTOM_CENTER,
                                                        autoClose: 1500,
                                                    });
                                                    setAdditionAccessPointCount(''); // clear invalid value
                                                }
                                            }}
                                            onKeyDown={(e) => {
                                                const allowedKeys = [
                                                    "Backspace",
                                                    "Delete",
                                                    "ArrowLeft",
                                                    "ArrowRight",
                                                    "Tab",
                                                ];
                                                const isDigit = /\d/.test(e.key);
                                                if (
                                                    (isDigit || allowedKeys.includes(e.key)) &&
                                                    (additionAccessPointCount.length < 6 || e.key === "Backspace")
                                                ) {
                                                    return true;
                                                } else {
                                                    e.preventDefault();
                                                }
                                            }}
                                        />
                                        <label htmlFor="additionalAcAmount" className="mt-2">
                                            Additional APs Discounted Price
                                        </label>
                                    </div>
                                </div>


                                <div className="col-12 col-md-6">
                                    <div className="mt-2">
                                        <label htmlFor="pgName1" className="pg-lable-style">
                                            Number of Wired LAN Ports
                                        </label>
                                        <input
                                            type="text"
                                            placeholder="Number of Wired LAN Ports"
                                            className="form-control input-text form-control-sm pg-input-style"
                                            id="noOfWiredLan"
                                            name="noOfWiredLan"
                                            value={noOfWiredLan}
                                            onChange={handleChangeNoOfWiredLan}
                                            onKeyDown={(e) => {
                                                const allowedKeys = [
                                                    "Backspace",
                                                    "Delete",
                                                    "ArrowLeft",
                                                    "ArrowRight",
                                                    "Tab",
                                                ];
                                                const isDigit = /\d/.test(e.key);
                                                if (
                                                    (isDigit || allowedKeys.includes(e.key)) &&
                                                    (noOfWiredLan.length < 6 || e.key === "Backspace")
                                                ) {
                                                    return true;
                                                } else {
                                                    e.preventDefault();
                                                }
                                            }}
                                        />

                                    </div>
                                </div>

                                {Number(noOfWiredLan) > 0 && (
                                    <div className="col-12 col-md-6">
                                        <div>
                                            <label className="select-search-label mt-1">
                                                Wired LAN Devices
                                            </label>
                                            <Select
                                                className="basic-single form-control form-control-sm p-1"
                                                classNamePrefix="select"
                                                name="wiredLanDevices"
                                                placeholder="Select Wired LAN Devices"
                                                styles={style}
                                                value={wiredLanDevices}
                                                isSearchable={false}
                                                isMulti // ✅ make it multi select
                                                onChange={handleSelectWiredLanDevices}
                                                options={optionWiredLanDevices}
                                            />

                                        </div>
                                    </div>)}

                                {Number(noOfWiredLan) > 0 &&
                                    wiredLanDevices.some((d) => d.value === "OtherWiredLanDevice") && (
                                        <div className="col-12 col-md-6">
                                            <div className="mt-2">
                                                <label htmlFor="pgName1" className="pg-lable-style">
                                                    Specific Device Name
                                                </label>
                                                <input
                                                    type="text"
                                                    placeholder="Specific Device Name"
                                                    className="form-control input-text form-control-sm pg-input-style"
                                                    id="nameOfOtherWLD"
                                                    name="nameOfOtherWLD"
                                                    value={nameOfOtherWLD}
                                                    onChange={handleChangeNameOfOtherWLD}
                                                />
                                            </div>
                                        </div>)}

                                {Number(noOfWiredLan) > 0 && (
                                    <div className="col-12 col-md-6">
                                        <div className="mt-2">
                                            <label htmlFor="pgName1" className="pg-lable-style">
                                                LAN Port Add-on Charges
                                            </label>
                                            <input
                                                type="text"
                                                placeholder="LAN Port Add-on Charges"
                                                className="form-control input-text form-control-sm pg-input-style"
                                                id="lanPortAddonCharges"
                                                name="lanPortAddonCharges"
                                                value={lanPortAddonCharges}
                                                onChange={handleChangeLanPortAddonCharges}
                                                readOnly
                                                style={{ backgroundColor: "transparent" }}
                                                onKeyDown={(e) => {
                                                    const allowedKeys = [
                                                        "Backspace",
                                                        "Delete",
                                                        "ArrowLeft",
                                                        "ArrowRight",
                                                        "Tab",
                                                    ];
                                                    const isDigit = /\d/.test(e.key);
                                                    if (
                                                        (isDigit || allowedKeys.includes(e.key)) &&
                                                        (lanPortAddonCharges.length < 6 || e.key === "Backspace")
                                                    ) {
                                                        return true;
                                                    } else {
                                                        e.preventDefault();
                                                    }
                                                }}
                                            />

                                        </div>
                                    </div>)}

                                {Number(noOfWiredLan) > 0 && (
                                    <div className="col-12 col-md-6">
                                        <div className="mt-2">
                                            <label htmlFor="pgName1" className="pg-lable-style">
                                                LAN Port Add-on Charges Discount
                                            </label>
                                            <input
                                                type="text"
                                                placeholder="LAN Port Add-on Charges Discount"
                                                className="form-control input-text form-control-sm pg-input-style"
                                                id="lanPortAddonDiscount"
                                                name="lanPortAddonDiscount"
                                                value={lanPortAddonDiscount}
                                                onChange={handleChangeLanPortAddonDiscount}
                                                // style={{ backgroundColor: "transparent" }}
                                                onKeyDown={(e) => {
                                                    const allowedKeys = [
                                                        "Backspace",
                                                        "Delete",
                                                        "ArrowLeft",
                                                        "ArrowRight",
                                                        "Tab",
                                                    ];
                                                    const isDigit = /\d/.test(e.key);
                                                    if (isDigit || allowedKeys.includes(e.key)) {
                                                        return true;
                                                    } else {
                                                        e.preventDefault();
                                                    }
                                                }}
                                            />
                                            {lanPortAddonDiscount > 0 &&
                                                <div className='p-1'>
                                                    <span className="px-1 py-1 text-danger" >Proposal will be generated after DOA approval</span>
                                                </div>}
                                        </div>
                                    </div>)}




                                {/* <div className="col-12 col-md-6">
                                    <div className="">
                                        <label className="select-search-label mt-1">
                                            Select APs Count
                                        </label>
                                        <Select
                                            className=" basic-single form-control form-control-sm p-1"
                                            classNamePrefix="select"
                                            name="accessPointCount"
                                            placeholder="Select Access Point"
                                            styles={style}
                                            value={accessPointCount}
                                            isSearchable={false}
                                            onChange={handleSelectAccessPointCount}
                                            options={optionAccessPointCount.map((data) => ({
                                                value: data.value,
                                                label: data.label,
                                            }))}
                                        />
                                    </div>
                                </div> */}


                                <div className="col-12 col-md-6">
                                    <div className="">
                                        <label className="select-search-label mt-1">
                                            Select APs Count
                                        </label>
                                        <Select
                                            className="basic-single form-control form-control-sm p-1"
                                            classNamePrefix="select"
                                            name="accessPointCount"
                                            placeholder="Select Access Point"
                                            styles={style}
                                            value={accessPointCount}
                                            isSearchable={false}
                                            onChange={(selected) => {
                                                setAccessPointCount(selected);
                                                setPlanName("");
                                                setPlanDataShowAB("");
                                                setOtcPriceB("");
                                                const selectedValue = Number(selected.value);
                                                const recommendedValue = Number(recommendedAps);

                                                if (selectedValue < recommendedValue) {
                                                    // toast.warning(
                                                    //     `⚠️ Warning: The recommended number of APs for this site is ${recommendedValue}, but you have selected ${selectedValue}. Fewer Access Points may lead to inadequate Wi-Fi coverage or performance degradation.`
                                                    // );
                                                    alert(`The recommended number of APs for this site is ${recommendedValue}, but you have selected ${selectedValue}. Fewer Access Points may lead to inadequate Wi-Fi coverage or performance degradation.`)
                                                }
                                            }}
                                            // options={optionAccessPointCount.map((data) => ({
                                            //     value: data.value,
                                            //     label: data.label,
                                            // }))}
                                            options={[
                                                ...(doesCustNeedStaticIP === "111260000"
                                                    ? [{ label: "1", value: "1" }]
                                                    : []),
                                                ...optionAccessPointCount
                                            ].map((data) => ({
                                                value: data.value,
                                                label: data.label,
                                            }))}
                                        />
                                    </div>
                                </div>

                                {/* {console.log("accessPointCount",accessPointCount)} */}




                                <div className="col-12 col-md-6">
                                    <div className="">
                                        <label className="select-search-label mt-1">
                                            Select Plan Name
                                        </label>
                                        <Select
                                            className=" basic-single form-control form-control-sm p-1"
                                            classNamePrefix="select"
                                            name="PlanName"
                                            placeholder="Select Option"
                                            styles={style}
                                            value={planName}
                                            isSearchable={false}
                                            onChange={handleSelectPlanName}
                                            // options={optionPlanName.map((data) => ({
                                            //     value: data.value,
                                            //     label: data.label,
                                            // }))}
                                            options={optionPlanName}
                                        // getOptionValue={(opt) => `${opt.plan_tier}|${opt.speedMbps}|${opt.dataTB}`}
                                        // getOptionLabel={(opt) => opt.label}
                                        />
                                    </div>
                                </div>
                                {upgradeNote ? (
                                    <div className="alert alert-info mt-2" role="alert">
                                        {upgradeNote}
                                    </div>
                                ) : ""}



                                <div className="col-12 col-md-6">
                                    <div className="mt-2">
                                        <label htmlFor="pgName1" className="pg-lable-style">
                                            OTC Price
                                        </label>
                                        <input
                                            type="text"
                                            placeholder="Base Price"
                                            className="form-control input-text form-control-sm pg-input-style"
                                            id="basePrice"
                                            name="basePrice"
                                            // value={userPriceData.basePrice}
                                            value={otcPriceB}
                                        // onChange={handleChange}
                                        />

                                    </div>
                                </div>

                                <div className="col-12 col-md-6">
                                    <div className="mt-2">
                                        <label htmlFor="pgName1" className="pg-lable-style">
                                            Add OTC Discount
                                        </label>
                                        <input
                                            type="text"
                                            placeholder="Enter Base price Discount"
                                            className="form-control input-text form-control-sm pg-input-style"
                                            id="basePriceDisB"
                                            name="basePriceDisB"
                                            value={basePriceDisB}
                                            onChange={handleBasePriceDisB}
                                            // onBlur={calculateDiscountedPriceB}
                                            disabled={oppStatus !== "Open"}
                                            style={{ background: "transparent" }}
                                            onKeyDown={(e) => {
                                                const allowedKeys = [
                                                    "Backspace",
                                                    "Delete",
                                                    "ArrowLeft",
                                                    "ArrowRight",
                                                    "Tab",
                                                ];
                                                const input = e.target.value;

                                                // Prevent entering '0' as the first character
                                                // if (input.length === 0 && e.key === "0") {
                                                //     e.preventDefault();
                                                //     return;
                                                // }
                                                const isDigit = /\d/.test(e.key);
                                                if (
                                                    (isDigit || allowedKeys.includes(e.key))
                                                    //   &&  (basePriceDis < 10 || e.key === "Backspace")
                                                ) {
                                                    return true;
                                                } else {
                                                    e.preventDefault();
                                                }
                                            }}
                                        />
                                    </div>
                                    {basePriceDisB > 0 &&
                                        <div className='p-1'>
                                            <span className="px-1 py-1 text-danger" >Proposal will be generated after DOA approval</span>
                                        </div>}
                                </div>

                                <div className="col-12 col-md-6">
                                    <div className="mt-">
                                        <label htmlFor="pgName1" className="pg-lable-style">
                                            Reason Of Discount
                                        </label>
                                        <input
                                            type="text"
                                            placeholder="Enter Base price Discount"
                                            className="form-control input-text form-control-sm pg-input-style"
                                            id="basePriceReasonB"
                                            name="basePriceReasonB"
                                            value={userPriceData.basePriceReasonB}
                                            onChange={handleChange}
                                        />
                                    </div>

                                </div>
                            </>
                            {/* )} */}

                        </div>





                        <>
                            <div className="table-responsive mt-4">
                                <table className="table table-bordered custom-table">
                                    <thead>
                                        <tr className="table-dark">
                                            <th className="border border-black py-2">Parameter</th>
                                            <th className="border border-black py-2">Details</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {Array.isArray(planDataShowAB) &&
                                            planDataShowAB.map((item, index) => (
                                                <React.Fragment key={index}>
                                                    {/* Plan Name */}
                                                    <tr>
                                                        <th>Plan Name</th>
                                                        <td>{item.plan_description}</td>
                                                    </tr>

                                                    {/* Office Specs */}
                                                    <tr>
                                                        <th rowSpan="2">Office Specifications</th>
                                                        <td className="p-0">
                                                            <table className="table m-0 table-bordered">
                                                                <thead>
                                                                    <tr className="office-spec-header">
                                                                        <th>No. of Units</th>
                                                                        <th>Carpet Area</th>
                                                                        <th>Employee Count</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    <tr>
                                                                        <td>{noOfUnit}</td>
                                                                        <td>{totalCarpetArea} sq.ft.</td>
                                                                        <td>{totalEmpCount}</td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </td>
                                                    </tr>
                                                    <tr></tr>

                                                    {/* Wi-Fi APs */}
                                                    <tr>
                                                        <th>Number of Wi-Fi Access Points</th>
                                                        <td>{accessPointCount ? accessPointCount?.value : recommendedAps} APs</td>
                                                    </tr>

                                                    {/* Plan Details */}
                                                    <tr>
                                                        <th>Speed</th>
                                                        <td>{item.broadband_speed}</td>
                                                    </tr>
                                                    <tr>
                                                        <th>Speed Post FUP</th>
                                                        <td>{item.speed_post_fup ? item.speed_post_fup : "NA"}</td>
                                                    </tr>
                                                    <tr>
                                                        <th>Data Volume</th>
                                                        <td>{item.data}</td>
                                                    </tr>
                                                </React.Fragment>
                                            ))}
                                    </tbody>

                                </table>
                            </div>


                            {/* Table for Charges */}
                            <div className="table-responsive mt-4">
                                <table className="table table-bordered custom-table">
                                    <thead>
                                        <tr className="table-dark">
                                            <th className="border border-black py-2">Charge Type</th>
                                            <th className="border border-black py-2">Charges</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <th>One Time Charges (OTC)</th>
                                            <td>
                                                {/* {discountedBasePriceB
                                                    ? discountedBasePriceB
                                                    : planDataShowAB?.[0]?.otc} */}
                                                {discountedBasePriceB
                                                    ? discountedBasePriceB
                                                    : otc}
                                            </td>
                                        </tr>
                                        <tr>
                                            <th>Monthly Recurring Charges</th>
                                            <td>
                                                {planDataShowAB?.[0]?.monthly_price}
                                            </td>
                                        </tr>
                                        <tr>
                                            <th>LAN Port Add-on Charges</th>
                                            <td>
                                                {extendedLanCharges ? extendedLanCharges : lanPortAddonCharges}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </>

                        <div className=" text-center p-5">
                            <button
                                type="button"
                                className="btn text-light submit-btn bg-dark mx-auto rounded-pill"
                                onClick={handleCreateProductAB}
                            >
                                Generate Proposal
                            </button>
                        </div>
                    </fieldset>
                </div>
            )}
        </>
    )
}

export default SelectProductProwifi